import React from "react";
import { Card, Row, Col, Typography } from "antd";

const { Title, Text } = Typography;

const RotoTemplateDetails = ({ data }) => {
  return (
    <Card>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Row>
            <Col span={12}>
              <Text strong>Region:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.region || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Client Company:</Text>
            </Col>
            <Col span={12}>
              {data?.clientCompany && data?.clientCompany.length > 0 ? (
                data?.clientCompany.map((company) => (
                  <div key={company?.id}>{company?.name}</div>
                ))
              ) : (
                <Text>...</Text>
              )}
            </Col>
          </Row>
          <div>
            <Text strong>Bidding Company:</Text>
            {data?.biddingCompany && data?.biddingCompany.length > 0 ? (
              data?.biddingCompany.map((company, index) => (
                <Card
                  key={index}
                  type="inner"
                  //   title={`Bidding Company ${index + 1}`}
                >
                  <Row>
                    <Col span={12}>
                      <Text strong>Company Info:</Text>
                    </Col>
                    <Col span={12}>
                      {company?.companyInfo &&
                      company?.companyInfo.length > 0 ? (
                        company?.companyInfo.map((info) => (
                          <div key={info?.id}>{info?.name}</div>
                        ))
                      ) : (
                        <Text>...</Text>
                      )}
                    </Col>
                  </Row>

                  <Row>
                    <Col span={12}>
                      <Text strong>Bid Amount:</Text>
                    </Col>
                    <Col span={12}>
                      {company?.bidAmount && company?.bidAmount.length > 0 ? (
                        company?.bidAmount.map((amount) => (
                          <div key={amount?.id}>
                            {amount?.name}: {amount?.amount}
                          </div>
                        ))
                      ) : (
                        <Text>...</Text>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Text strong>Remarks:</Text>
                    </Col>
                    <Col span={12}>
                      <Text>{company?.remarks || "..."}</Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Text strong>Awarded Yes/No:</Text>
                    </Col>
                    <Col span={12}>
                      <Text>{company?.awardedYesOrNo || "..."}</Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Text strong>Rank:</Text>
                    </Col>
                    <Col span={12}>
                      <Text>{company?.rank || "..."}</Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Text strong>Difference Amount L1:</Text>
                    </Col>
                    <Col span={12}>
                      <Text>{company?.diffAmountL1 || "..."}</Text>
                    </Col>
                  </Row>
                </Card>
              ))
            ) : (
              <Text>...</Text>
            )}
          </div>
          <Row>
            <Col span={12}>
              <Text strong>Tender No:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.tenderNo || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Project Name:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.projectName || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Procurement:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.procurement || "..."}</Text>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Text strong>Category:</Text>
            </Col>
            <Col span={12}>
              {data?.category && data?.category.length > 0 ? (
                data?.category.map((category) => (
                  <div key={category?.id}>{category?.name}</div>
                ))
              ) : (
                <Text>...</Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Sub Category:</Text>
            </Col>
            <Col span={12}>
              {data?.subCategory && data?.subCategory.length > 0 ? (
                data?.subCategory.map((subCategory) => (
                  <div key={subCategory?.id}>{subCategory?.name}</div>
                ))
              ) : (
                <Text>...</Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Sector:</Text>
            </Col>
            <Col span={12}>
              {data?.sector && data?.sector.length > 0 ? (
                data?.sector.map((sector) => (
                  <div key={sector?.id}>{sector?.name}</div>
                ))
              ) : (
                <Text>...</Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Sub Sector:</Text>
            </Col>
            <Col span={12}>
              {data?.subSector && data?.subSector.length > 0 ? (
                data?.subSector.map((subSector) => (
                  <div key={subSector?.id}>{subSector?.name}</div>
                ))
              ) : (
                <Text>...</Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>SOW:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.sow || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Country:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.country || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Bidding Opening Date:</Text>
            </Col>
            <Col span={12}>
              <Text>
                {data?.biddingOpeningDate
                  ? new Date(data?.biddingOpeningDate).toLocaleDateString()
                  : "..."}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Intended To Award:</Text>
            </Col>
            <Col span={12}>
              <Text>
                {data?.intendedToAward
                  ? new Date(data?.intendedToAward).toLocaleDateString()
                  : "..."}
              </Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Shortlisted Date:</Text>
            </Col>
            <Col span={12}>
              <Text>
                {data?.shortlistedDate
                  ? new Date(data?.shortlistedDate).toLocaleDateString()
                  : "..."}
              </Text>
            </Col>
          </Row>
          {/* <Row>
            <Col span={12}>
              <Text strong>Total Equivalent Price NPR:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.totalEquivPriceNPR || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Difference With L1:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.diffWithL1 || "..."}</Text>
            </Col>
          </Row> */}
          {/* <Row>
            <Col span={12}>
              <Text strong>Difference With Estimate:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.diffWithEstimate || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Winning Bidder:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.winningBidder || "..."}</Text>
            </Col>
          </Row> */}
          <Row>
            <Col span={12}>
              <Text strong>Type Of Notice:</Text>
            </Col>
            <Col span={12}>
              <Text>{data?.typeOfNotice || "..."}</Text>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Text strong>Notice Date:</Text>
            </Col>
            <Col span={12}>
              <Text>
                {data?.noticeDate
                  ? new Date(data?.noticeDate).toLocaleDateString()
                  : "..."}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default RotoTemplateDetails;
